import {
  AutoComplete,
  Button,
  Drawer,
  Form,
  Input,
  Modal,
  Select,
  Spin,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import { EditOutlined } from "@ant-design/icons";
import TopHeading from "./TopHeading";
import Empty from "../common/Empty";
import AddVehicleType from "./AddVehicleType";
import { debounce } from "lodash";
const { Option } = Select;

const VehicleTypeList = () => {
  const [status, setStatus] = useState("");
  const [limit, setLimit] = useState(16);
  const [visible, setVisible] = useState(undefined);
  const [key, setKey] = useState<string>();

  const [vehicleData, setVehicleData] = useState({
    loading: false,
    data: null,
  });

  const [vehicleOptions, setVehicleOptions] = useState({
    loading: false,
    list: [],
  });

  const [selectedLocationForEdit, setSelectedLocationForEdit] =
    useState(undefined);

  const [form] = Form.useForm();
  const loc = useLocation();

  const reseAllFieldData = () => {
    setStatus("");
    setKey("");
    form.resetFields();
  };

  const getVehicleLocation = useCallback(async () => {
    setVehicleData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
    axios
      .get(
        `${encodedUri}/admin/vehicle-type/all` +
          (key ? `?vehicle-type=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setVehicleData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setVehicleData({ loading: false, data: [] });
        console.error("Locations: Error", err);
      });
  }, [key]);

  const getVehicleOptions = useCallback(async (key) => {
    setVehicleOptions({ loading: true, list: null });
    const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
    return axios
      .get(
        `${encodedUri}/admin/vehicle-type/all` +
          (key ? `?vehicle-type=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setVehicleOptions({
          loading: false,
          list: res.data?.vehicleTypes?.map((vehicle) => ({
            label: vehicle.vehicleType,
            value: vehicle.vehicleType,
          })),
        });
      })
      .catch((err) => {
        setVehicleOptions({ loading: false, list: [] });
        console.error("Locations: Error", err);
      });
  }, []);

  const fetchRef = useRef(0);
  const debounceLocationOptionsFetcher = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      getVehicleOptions(value);
    };

    return debounce(loadOptions, 800);
  }, [getVehicleOptions]);

  //

  useEffect(() => {
    if (visible) {
      setSelectedLocationForEdit(undefined);
    }
  }, [selectedLocationForEdit, visible]);

  useEffect(() => {
    setSelectedLocationForEdit(undefined);
  }, [visible]);

  useEffect(() => {
    getVehicleLocation();
    getVehicleOptions("");
  }, [getVehicleLocation, getVehicleOptions]);

  const onClose = () => {
    setSelectedLocationForEdit(null);
    getVehicleLocation();
  };

  return (
    <React.Fragment>
      <TopHeading
        {...vehicleData?.data?.totalElements}
        refetch={getVehicleLocation}
      />
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item name="search">
            <AutoComplete
              style={{ width: 300 }}
              onSearch={debounceLocationOptionsFetcher}
              onSelect={(val) => setKey(val.toString())}
              options={vehicleOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                vehicleOptions?.loading ? <Spin size="small" /> : null
              }
            >
              <Input.Search
                placeholder="Search by Name"
                onSearch={(val) => setKey(val)}
                enterButton
                loading={vehicleOptions.loading}
              />
            </AutoComplete>
          </Form.Item>
        </Form>

        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Vehicle</span>
                  </div>

                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {vehicleData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {vehicleData?.data?.vehicleTypes?.length ? (
                    vehicleData?.data?.vehicleTypes?.map(
                      (type: any, index: any) => (
                        <React.Fragment key={index}>
                          <div className="single-product-wrapper">
                            <div className="single-product">
                              <span className="name">{type?.vehicleType}</span>
                            </div>
                            <div className="single-product">
                              <button
                                className="btn btn-sm btn-warning mx-1"
                                onClick={() => setSelectedLocationForEdit(type)}
                              >
                                <EditOutlined />
                              </button>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Locations" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Modal
            title="Edit Vehicle Type"
            visible={selectedLocationForEdit}
            onCancel={onClose}
            okText={`Submit`}
            footer={false}
          >
            <AddVehicleType
              visibleData={selectedLocationForEdit}
              onCloseMethod={onClose}
            />
          </Modal>

          <PaginationTwo
            {...vehicleData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default VehicleTypeList;
